function show_dann_cart(t, e, a) {
  if ("cart" == t)
    return fetch("/cart?view=ajax&timestamp=" + Date.now(), {
      credentials: "same-origin",
      method: "GET",
    }).then(function (t) {
      t.text().then(function (t) {
        "add" == e && jQuery(".cart-items").prepend(t),
          "remove" == e && $(".cart-item-gwp").remove();
        let a = 1;
        jQuery(".cart-items .cart-item").each(function () {
          jQuery(this).attr("data-line", a), a++;
        }),
          jQuery.getJSON("/cart/update.js", function (t) {
            t.item_count > 0 &&
              ($("span.cart-counter").addClass("has-product"),
              $("span.cart-counter").html(t.item_count));
          });
      });
    });
  jQuery.getJSON("/cart/update.js", function (t) {
    t.item_count > 0 &&
      ($("span.cart-counter").addClass("has-product"),
      $("span.cart-counter").html(t.item_count)),
      new GoCart().renderMiniCart(t);
  });
}
function add_product_to_cart(t, e) {
  if ("" != count_max_cart && "" != add_product_when_max) {
    let n = t.items,
      s = 0;
    n.forEach(function (t) {
      t.id == add_product_when_max && s++;
    });
    let o = 0,
      r = 0;
    n.forEach(function (t) {
      let e = t.product_title;
      "Free Gift w/ Purchase" != e &&
        e.toLowerCase().startsWith("free") &&
        (r = t.line_price),
        "Monthly Daily Essential Skincare Routine" == e && (r = t.line_price);
    });
    let i = t.total_price;
    if ((r > 0 && (i = t.total_price - r), i >= count_max_cart)) {
      if (0 == s) {
        let a = { id: add_product_when_max, quantity: 1 };
        jQuery.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: a,
          dataType: "json",
          success: function () {
            show_dann_cart(e, "add", t), o++;
          },
        });
      }
    } else {
      var a = { id: add_product_when_max, quantity: 0 };
      jQuery.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: a,
        dataType: "json",
        success: function () {
          show_dann_cart(e, "remove", t), o++;
        },
      });
    }
    0 == o && "minicart" == e && show_dann_cart("minicart", "remove", t);
  }
}
!(function (t) {
  if (
    (t(".sub_menu_btn").on("click", function () {
      t(this).toggleClass("close_sub_menu"),
        t(".mobile_nav").hasClass("mobile-slide-nav") ||
          t(this).parent().next(".sub-menu-wrp").stop().slideToggle(),
        t(this).parent().toggleClass("openlist");
    }),
    t(".mobilelistnav a.has-children").on("click", function () {
      if ("#" == t(this).attr("href"))
        return t(this).parent().toggleClass("openlist"), !1;
    }),
    t(".sub-menu-header").on("click", function () {
      t(this).parent().prev(".parent-link-wrapper").removeClass("openlist"),
        t(this)
          .parent()
          .prev(".parent-link-wrapper")
          .children(".sub_menu_btn ")
          .removeClass("close_sub_menu");
    }),
    null !== navigator.platform.match("Mac") && t("body").addClass("osx-fixed"),
    t(".open_target").on("click", function () {
      return (
        t(t(this).data("target")).fadeIn().addClass("show"),
        t(this).addClass("show"),
        !1
      );
    }),
    t(".close_target").on("click", function () {
      return (
        t(t(this).data("target")).removeClass("show").fadeOut(),
        t(".open_target, .mobilebtn").removeClass("show"),
        t("body").removeClass("scroll-hidden"),
        !1
      );
    }),
    t(".mobilebtn").on("click", function () {
      return (
        t(this).hasClass("show")
          ? (t(t(this).data("target")).removeClass("show").fadeOut(),
            t(this).removeClass("show"),
            t("body").removeClass("scroll-hidden"))
          : (t(t(this).data("target")).fadeIn().addClass("show"),
            t(this).addClass("show"),
            t("body").addClass("scroll-hidden")),
        !1
      );
    }),
    t(window).on("scroll", function () {
      let e = t(window).scrollTop(),
        a = t(".header-sticky");
      e > 5 ? a.addClass("header_appear") : a.removeClass("header_appear");
    }),
    t(".js-go-cart-add-to-cart").click(function () {
      setTimeout(function () {
        jQuery.getJSON("/cart/update.js", function (e) {
          e.item_count > 0 &&
            (t("span.cart-counter").addClass("has-product"),
            t("span.cart-counter").html(e.item_count),
            add_product_to_cart(e, "minicart"));
        });
      }, 700);
    }),
    t(".head-search-btns svg.icon").on("click", function () {
      t(this).hasClass("modal__toggle-open")
        ? (t("details-modal.header__search").addClass("show"),
          t(this).addClass("hidden"))
        : (t("details-modal.header__search").removeClass("show"),
          t(".modal__toggle-open").removeClass("hidden"));
    }),
    t(".announcement-bar-click").length > 0)
  ) {
    let e = 0,
      a = t(".announcement-bar-click").height();
    1 == t(".announcement-bar").length && (e = t(".announcement-bar").height()),
      t("body").css({ "padding-top": +t("header.header").height() + e + a }),
      t(".js-close-announcement").on("click", function () {
        t("body").animate(
          { "padding-top": t("header.header").height() + e },
          300
        ),
          t(this).parent().animate({ height: "0" }, 300);
      });
  }
  t(window).width() < 769 &&
    t(".js-box-links-title").on("click", function () {
      t(this).next(".menu-footer").stop().slideToggle();
    }),
    t(".ease-scroll").on("click", function (e) {
      e.preventDefault(),
        t("html, body").animate(
          { scrollTop: t(t.attr(this, "href")).offset().top - 80 },
          500
        );
    }),
    t(".js-search-window, .js-search-window-close").on("click", function () {
      t(".search-menu-editional").hasClass("active")
        ? t(".search-menu-editional").removeClass("active")
        : t(".search-menu-editional").addClass("active");
    });
  const e = location.protocol + "//" + location.host;
  t(".domains-menu li a").each(function () {
    t(this).attr("href") == e &&
      t(this)
        .parents("ul")
        .prev(".current-country")
        .children(".js-text-country")
        .text(t(this).text());
  }),
    t(".current-country").on("click", function () {
      t(this).next().stop().slideToggle();
    });
})(jQuery);


